export default __webpack_public_path__ + "dfd1f755e3a72ae96efd9fe052068698.svg";